// Every admin-gated page reads localStorage.getItem('adminLoggedIn') once
// in componentDidMount - that's enough for the page components since
// react-router remounts them on navigation, but CustomNavbar lives
// outside <Routes> and never remounts, so it never noticed a login that
// happened after it first mounted (only a full page refresh fixed it).
// This tiny custom event lets Login broadcast the change so the navbar
// can react immediately instead.
export const ADMIN_AUTH_EVENT = 'admin-auth-changed';

export const broadcastAdminAuthChange = () => {
    window.dispatchEvent(new Event(ADMIN_AUTH_EVENT));
};
